module.exports = __webpack_public_path__ + "static/media/library.02f5287a.svg";